import { useNavigate } from 'react-router-dom';

import { useBoasVindas as useBoasVindasDoNucleo } from '@maestra/core/telas/auth/useBoasVindas';

// AS BOAS-VINDAS DEPOIS DO CADASTRO: a regra (para onde vai quem chegou) mora no núcleo desde
// 01/11/2026, e o app usa a mesma (docs/PLANO-APP-NATIVO.md). A web entrega o `navigate`.

export const useBoasVindas = () => useBoasVindasDoNucleo({ ir: useNavigate() });
